import { useGetFavouriteGameIdsQuery } from '../../generated/graphql';
import { useIsLoggedIn } from '../auth/useIsLoggedIn';

export const useFavouriteGameIds = () => {
  const isLoggedIn = useIsLoggedIn();
  const { data } = useGetFavouriteGameIdsQuery({ skip: !isLoggedIn });

  return data?.favouriteGameIds || [];
};
